import React from 'react'
import style from './startsoon.module.css'

function Currentbysunny() {
  return (
    <div  className = {style.start_soon}>
        <img src='https://edge.uacdn.net/static/thumbnail/course/839810a20ab6455db8dfe774c7ca02d7.jpg?q=75&w=1000&fm=webp' alt='_Sumit_img' />
        <div>
          <p>ENGLISH   UPSC NDA</p>
          <h4>Super 30 NDA Practice Batch 2022: Course on Geography and Current Affairs</h4> 
          <p>Lesson 2  2 Mar 2022</p> 
          <p>Sunny Verma</p>  
        </div>
    </div>        
  )
}
export default Currentbysunny;